import Swiper from 'swiper/bundle';

const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`#${sliderElm.id}`, {
        slidesPerView: "auto",
        loop: false,
        navigation: {
            nextEl: `.image-slider-swiper-button-next-${sliderIdentifier}`,
            prevEl: `.image-slider-swiper-button-prev-${sliderIdentifier}`
        },
    });
}

const allSliders = $('.simple-image-slider-type-5');

allSliders.each((index, element) => buildSwiperSlider(element));